import { Component, EventEmitter, Input, Output } from '@angular/core';
import type { AbaRelogio } from './tela-relogio.component';

@Component({
  selector: 'app-seletor-aba-relogio',
  standalone: true,
  templateUrl: './seletor-aba-relogio.component.html'
})
export class SeletorAbaRelogioComponent {
  @Input() aba: AbaRelogio = 'horarios';

  @Output() selecionar = new EventEmitter<AbaRelogio>();
}
